import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api';
import { useParticipantTheme } from '../../utils/theme';
import ShareCard from './ShareCard';
import './Share.css';

/** Страница по QR-коду «Получить презентацию» с экрана проектора: /share/poll/<код> или /share/qa/<код>. */
function SharePage() {
    const { kind, ref } = useParams();
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    useParticipantTheme(data?.theme);

    useEffect(() => {
        document.title = 'Презентация спикера — СВОД';
        const load = async () => {
            try {
                if (kind === 'qa') {
                    const res = await api.get(`/public/qa/${ref}`);
                    setData({ title: res.data.session.title, theme: res.data.settings.theme, share: res.data.share });
                } else {
                    const res = await api.get(`/public/polls/${ref}`);
                    setData({ title: res.data.title, theme: res.data.theme, share: res.data.share });
                }
            } catch {
                setError('Страница не найдена — проверьте ссылку или QR-код.');
            }
        };
        if (kind === 'poll' || kind === 'qa') load();
        else setError('Страница не найдена — проверьте ссылку или QR-код.');
    }, [kind, ref]);

    return (
        <div className="share-page">
            <div className="share-page__inner">
                <div className="share-page__brand">СВОД</div>
                {error && <p>{error}</p>}
                {!data && !error && <p className="share-muted">Загрузка…</p>}
                {data && (
                    <>
                        <h1>{data.title}</h1>
                        <p className="share-page__source">Презентация спикера</p>
                        {data.share?.enabled
                            ? <ShareCard kind={kind} refId={ref} share={data.share} />
                            : <div className="share-card"><p>Организатор сейчас не делится презентацией.</p></div>}
                    </>
                )}
            </div>
        </div>
    );
}

export default SharePage;
